export class Detail {
   hasErrors?: boolean;
}
